import React from "react";

export type CrossIcon2Props = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 10,
    height: 10,
  },
  medium: {
    width: 16,
    height: 15,
  },
  large: {
    width: 36,
    height: 36,
  },
};

export const CrossIcon2: JSX.Element & any = React.forwardRef<
  SVGSVGElement,
  CrossIcon2Props
>((props, ref) => {
  const { size = "medium", width, height, color = "#E01B3F" } = props;
  const svgSize = width && height ? { width, height } : sizes[size];

  return (
    <svg
      ref={ref}
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.78636 0C11.9283 0 15.2852 3.35925 15.2852 7.5012C15.2852 11.6432 11.9277 15 7.78636 15C3.64441 15 0.285156 11.6426 0.285156 7.5012C0.285156 3.35925 3.64441 0 7.78636 0ZM7.67679 5.88105L4.76754 2.9718C3.77379 1.97805 2.25804 3.49388 3.25179 4.48755L6.26709 7.50285L3.25179 10.5164C2.25804 11.5119 3.77386 13.0259 4.76754 12.0321L7.78284 9.0168L10.7963 12.0321C11.7918 13.0259 13.3058 11.5118 12.3121 10.5164L9.29679 7.50285L12.3121 4.48755C13.324 3.47564 11.7953 1.97445 10.7963 2.9718L7.78284 5.9871L7.67679 5.88105Z"
        fill={color}
      />
    </svg>
  );
});

CrossIcon2.displayName = "CrossIcon2";
